import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { RequestStatus } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { Translation } from 'cng-common/features/translations/components/translation'
import { toFormat } from 'core/classes/helpers/DateHelper'

import { TRANSLATION_KEYS } from '../../../translations'

export const MDOffboardingMetadata = ({ request }: { request: IRequest }) => {
  const isCompleted = request.Status === RequestStatus.Done
  const isRejected = request.Status === RequestStatus.Rejected
  const dateMetadata = isCompleted
    ? { value: request.EndDate, key: TRANSLATION_KEYS.completedDate }
    : isRejected
      ? { value: request.RejectDate, key: TRANSLATION_KEYS.rejectedDate }
      : { value: request.StartDate || request.Created, key: TRANSLATION_KEYS.startedDate }
  const date = toFormat(dateMetadata.value, 'MMM D, YYYY')
  const showCreator = !isCompleted && !isRejected && Boolean(request.CreatedBy)

  return (
    <>
      {date && (
        <Translation
          text={dateMetadata.key}
          span
          replaceParams={[{ key: '{{date}}', value: date }]}
        />
      )}
      {date && showCreator && ' · '}
      {showCreator && (
        <Translation
          text={TRANSLATION_KEYS.createdBy}
          span
          replaceParams={[{ key: '{{name}}', value: request.CreatedBy }]}
        />
      )}
    </>
  )
}
